import { TransformInt } from '../../../shared/decorators/transform-int.decorator';

import { CreateVehicleCategoryDto } from './create-vehicle-category.dto';

/**
 * Update vehicle category DTO
 */
export class UpdateVehicleCategoryDto extends CreateVehicleCategoryDto {
	@TransformInt()
	id!: number;
}
